import React from 'react';
import { IconBaseProps } from 'react-icons';

import styles from './icon.module.scss';

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface IconProps extends Omit<IconBaseProps, 'size'> {
  icon: React.ComponentType<IconBaseProps>;
  size?: IconSize;
}

const sizeMap: Record<IconSize, number> = {
  xs: 12,
  sm: 14,
  md: 18,
  lg: 24,
  xl: 32
};

export const Icon: React.FC<IconProps> = ( {
  icon: IconComponent,
  size = 'md',
  className,
  ...props
} ) => {
  const iconSize = sizeMap[size];
  const iconClasses = [ styles.icon, className ].filter( Boolean ).join( ' ' );

  return (
    <IconComponent
      className={ iconClasses }
      size={ iconSize }
      { ...props }
    />
  );
};
